import React, { useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

import Button from "components/CustomButtons/Button.js";
import videoStyle from "assets/jss/material-kit-pro-react/views/salesSections/videoStyle.js";

import introVideo from "assets/videos/JoD_Parent_Course_Intro.mp4";

const useStyles = makeStyles(videoStyle);

export default function SectionTeam() {
  const classes = useStyles();
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  return (
    <div style={{ padding: "0 20px" }}>
      {/* HEADLINE */}
      <h2 className={classes.title + " " + classes.textCenter} style={{ fontSize: 36 }}>
        Most Parents Assume Swim Lessons = Safety
      </h2>

      {/* SUBHEADLINE */}
      <p className={classes.body5 + " " + classes.textCenter}>
        But in a real moment… many children don’t know what to do.
        <br />
        And most parents don’t realize what’s actually happening during lessons.
      </p>
      <p className={classes.body5 + " " + classes.textCenter} style={{ fontWeight: "bold" }}>
        <span role="img" aria-label="pointing down">👉</span> This is where understanding changes everything.
      </p>

      {/* BODY */}
      <div style={{ marginTop: 20 }}>
        <p className={classes.body5 + " " + classes.textCenter}>
          If your child fell into water today…
          <br />
          Would they know how to recover, float, and breathe — on their own?
        </p>

        <p className={classes.body5 + " " + classes.textCenter}>
          And more importantly…
        </p>

        <p className={classes.body5 + " " + classes.textCenter} style={{ fontWeight: "bold" }}>
          Would you know what to look for to know they’re actually learning it?
        </p>
      </div>

      {/* BULLETS */}
      <div
        style={{
          marginTop: 20,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <ul style={{ textAlign: "left" }}>
          <li>What actually keeps a child safe in the water</li>
          <li>What your child is really learning during lessons</li>
          <li>What progress should look like</li>
          <li>What YOU should be doing between lessons</li>
        </ul>
      </div>

      {/* CLOSING */}
      <div style={{ marginTop: 20 }}>
        <p className={classes.body5 + " " + classes.textCenter}>
          This course shows you exactly what’s happening behind the scenes — so you can support your child the right way.
        </p>
        <p className={classes.body5 + " " + classes.textCenter} style={{ fontWeight: "bold" }}>
          Not guess. Not hope. Actually understand.
        </p>
      </div>

      {/* VIDEO LABEL */}
      <h4 className={classes.title + " " + classes.textCenter} style={{ marginTop: 40, fontSize: 24 }}>
        <span role="img" aria-label="pointing down">👉</span> Watch This First (1 minute)
      </h4>

      {/* VIDEO */}
      <div className={classes.iframeContainer} style={{ position: "relative" }}>
        <video
          ref={videoRef}
          width="100%"
          muted
          controls={isPlaying}
          style={{ display: "block" }}
        >
          <source src={introVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {!isPlaying && (
          <div
            onClick={handlePlay}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.4)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              cursor: "pointer",
            }}
          >
            <div style={{ fontSize: "60px", marginBottom: "10px" }}>▶</div>
            <div style={{ fontSize: "18px", fontWeight: "bold" }}>
              Watch Preview
            </div>
          </div>
        )}
      </div>

      {/* CTA */}
      <div style={{ display: "flex", justifyContent: "center", marginTop: 30 }}>
        <Button
          href="https://survivalswimcourse.com/"
          color={"info"}
          target="_blank"
          size="lg"
          className={classes.mlAuto + " " + classes.mrAuto}
          round
        >
          Watch How This Actually Works
        </Button>
      </div>

      {/* SUPPORT TEXT */}
      <div style={{ marginTop: 20 }}>
        <p className={classes.body5 + " " + classes.textCenter}>
          Watch the first 60 seconds — and you’ll start to see what most parents miss.
        </p>
        <p className={classes.body5 + " " + classes.textCenter}>
          • Based on 15,000+ children taught
          <br />
          • Used by parents to better support lessons
        </p>
      </div>

      {/* SOCIAL PROOF */}
      <div style={{ marginTop: 50 }}>
        <h4 className={classes.title + " " + classes.textCenter} style={{ fontSize: 36 }}>
          <span role="img" aria-label="pointing down">👉</span> What Parents Are Already Seeing
        </h4>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
            gap: "20px",
            marginTop: 20,
          }}
        >
          <div>
            <p>
              “My daughter was afraid of water… within two classes she was floating and now she loves it.”
            </p>
            <p><strong>— Preeya Alestas</strong></p>
          </div>

          <div>
            <p>
              “Our child learned to float by lesson #2. It’s such a relief knowing they’re safe around water.”
            </p>
            <p><strong>— Angela Sundwall</strong></p>
          </div>

          <div>
            <p>
              “All 4 of my kids learned survival skills early — they can float, recover, and stay safe without floaties.”
            </p>
            <p><strong>— Alicia Rose Bell</strong></p>
          </div>
        </div>
      </div>
    </div>
  );
}
